export default {
  GET_ALL_CAFES_LOADING: 'GET_ALL_CAFES_LOADING',
  GET_ALL_CAFES_SUCCESS: 'GET_ALL_CAFES_SUCCESS',
  GET_ALL_CAFES_FAILED: 'GET_ALL_CAFES_FAILED',
  GET_ALL_CAFES_REJECT: 'GET_ALL_CAFES_REJECT',

  GET_CAFE_DETAILS_LOADING: 'GET_CAFE_DETAILS_LOADING',
  GET_CAFE_DETAILS_SUCCESS: 'GET_CAFE_DETAILS_SUCCESS',
  GET_CAFE_DETAILS_FAILED: 'GET_CAFE_DETAILS_FAILED',
  GET_CAFE_DETAILS_REJECT: 'GET_CAFE_DETAILS_REJECT',

  SEARCH_CAFES_LOADING: 'SEARCH_CAFES_LOADING',
  SEARCH_CAFES_SUCCESS: 'SEARCH_CAFES_SUCCESS',
  SEARCH_CAFES_FAILED: 'SEARCH_CAFES_FAILED',
  SEARCH_CAFES_REJECT: 'SEARCH_CAFES_REJECT',

  CAFE_NAMES_LIST_AND_FILTER_LOADING: 'CAFE_NAMES_LIST_AND_FILTER_LOADING',
  CAFE_NAMES_LIST_AND_FILTER_SUCCESS: 'CAFE_NAMES_LIST_AND_FILTER_SUCCESS',
  CAFE_NAMES_LIST_AND_FILTER_FAILED: 'CAFE_NAMES_LIST_AND_FILTER_FAILED',
  CAFE_NAMES_LIST_AND_FILTER_REJECT: 'CAFE_NAMES_LIST_AND_FILTER_REJECT',

  GET_DYNAMIC_CAFES_BY_TYPE_LOADING: 'GET_DYNAMIC_CAFES_BY_TYPE_LOADING',
  GET_DYNAMIC_CAFES_BY_TYPE_SUCCESS: 'GET_DYNAMIC_CAFES_BY_TYPE_SUCCESS',
  GET_DYNAMIC_CAFES_BY_TYPE_FAILED: 'GET_DYNAMIC_CAFES_BY_TYPE_FAILED',
  GET_DYNAMIC_CAFES_BY_TYPE_REJECT: 'GET_DYNAMIC_CAFES_BY_TYPE_REJECT',
};